import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { NewReusableCustomQuestionGroup } from "../../shared/interfaces/ReusableCustomQuestionGroup";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useCustomQuestionGroupCreate(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["customQuestionGroupCreate"],
    async (customQuestionGroup: NewReusableCustomQuestionGroup) =>
      apiContext.customWorkflowQuestionApis.createCustomQuestionGroup(customQuestionGroup),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
